// extracted by mini-css-extract-plugin
export default {"timeend":"Banned_timeend__LKZY4","timeend_dots":"Banned_timeend_dots__ixeeW","timeend_btn":"Banned_timeend_btn__EaOwZ"};